import { nanoid } from "nanoid";

export const generateId = (): string => nanoid(12);
